export const isIOS = () => /iPad|iPhone|iPod/.test(window.navigator.userAgent)